import React from 'react';
import { Game } from './features/game/Game';
import styles from './App.module.css';

function App() {
  return (
    <div className={styles.container}>
        <Game />
        
    </div>
  );
}

export default App;
